export const MAX_NFTS_TO_SHOW_AT_ONCE = 3;